import { capitalizeFirstLetter, advancedNormalizeDate } from '@/helpers';
import { ButtonWithDropDownMenu } from '../molecules';
import { Button, RowSpacer } from '../atoms';
import { IncidentReportDetailModal, AddIncidentReportFormModal } from '../templates';
import {
  useAddIncidentReportFormModalContext,
  useIncidentDetailContext,
  useIncidentReportDetailModalContext,
  useUserLanguage,
} from '@/customHooks';
import textsData from '@/textData/IncidentDetailReportsListTexts.json'

export const IncidentDetailReportsList = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  const { incident } = useIncidentDetailContext()

  const { openModal } = useAddIncidentReportFormModalContext()
  const { openModal: openDetailModal } = useIncidentReportDetailModalContext()

  return (
    <>
      <RowSpacer height={3} />
      <div className="flex justify-end">
        <Button onClick={() => openModal()}>{texts.buttons.addReport}</Button>
      </div>
      {!incident?.incidentReports || incident.incidentReports.length === 0 ? (
        <p className="mt-4"><b>{texts.noData}</b></p>
      ) : (
        <div className="mt-4 w-full overflow-x-auto rounded-xl border border-[var(--color-border)] bg-white py-4">
          <div className="min-w-[480px]">
            <div className="grid grid-cols-[1fr_1fr_64px] border-b border-gray-300 font-bold">
              <div className="px-4 py-3 text-left">{texts.subject}</div>
              <div className="px-4 py-3 text-left">{texts.lastUpdated}</div>
              <div className="px-4 py-3" />
            </div>
            {incident.incidentReports.map((report, index) => (
              <div
                key={report.id}
                className={`grid grid-cols-[1fr_1fr_64px] text-sm ${index % 2 !== 0 ? 'bg-background2' : 'bg-white'}`}
              >
                <div className="flex items-center px-4 py-4">{capitalizeFirstLetter(report.subject)}</div>
                <div className="flex items-center px-4 py-4">
                  <span title={report.updatedAt}>
                    {advancedNormalizeDate(userLanguage, report.updatedAt)}
                  </span>
                </div>
                <div className="flex items-center justify-end px-4 py-4">
                  <ButtonWithDropDownMenu
                    options={[{ item: texts.dropdownMenu.details, action: () => openDetailModal(report.id) }]}
                    position="left"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      <IncidentReportDetailModal />
      <AddIncidentReportFormModal />
    </>
  );
};
